import { useContext } from 'react';
import menuOptions, { MenuOptionLabel } from '~/constants/srp/MenuOption';
import ModalContext from '~/context/srp/ModalContext';
import SearchContext from '~/context/srp/SearchContext';
import CaretRight from '~/icons/CaretRight';

export default function MenuOptions() {
  const { setFilterModalOpen } = useContext(ModalContext);
  const { setExpandOnOpen } = useContext(SearchContext);

  const handleClick = (option: MenuOptionLabel) => {
    setExpandOnOpen(option);
    setFilterModalOpen(true);
  };

  return (
    <div className="max-w-[calc(100vw-var(--scrollbar-width,0px))] overflow-hidden m:hidden">
      <div className="no-scrollbar grid gap-8 overflow-auto border-b border-grey-2 p-16">
        <div className="flex items-center gap-8">
          {menuOptions.map(({ key, label }) => (
            <button
              className="flex items-center gap-[2px] whitespace-nowrap rounded-[20px] border border-grey-2 bg-white px-12 py-8 text-blue-6 tl-header-xs"
              data-analytics-id="Filter Menu"
              data-analytics-attributes={JSON.stringify({
                item: 'shortcut button',
                label
              })}
              data-qa={`menu-option-${key}`}
              onClick={() => handleClick(label)}
              key={key}
            >
              {label}

              <CaretRight className="h-16 w-16" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
